import { getMockVendorProfile } from "../../../mocks/mockVendorProfile";

export const mockAccountProvider = {
  modificaAccount: async () => ({
    data: {
      statusCode: 202,
      message: "Mock: modifiche account applicate. Dovrai effettuare nuovamente il login.",
    },
  }),
  eliminaAccount: async () => ({
    data: {
      statusCode: 202,
      message: "Mock: account eliminato.",
    },
  }),
  getVendorProfile: async () => ({
    data: getMockVendorProfile(),
  }),
};

